export enum ReminderStatus {
    NOT_APPLICABLE = 'N/A',
    RESCHEDULED = 'Rescheduled',
    PATIENT_CANCELLED = 'Patient Cancelled',
    CONFIRMED = 'Confirmed',
    REMINDED = 'Reminded',
}
